import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';

import { NavBlock } from '../types';

/**
 * @description Formatted list of jb navigation blocks with secondary color pallet
 * @WhereIsItUsed secondary-nav-block-list-container
 */
@Component({
  selector: 'jb-secondary-nav-block-list',
  templateUrl: './secondary-nav-block-list.component.html',
  styleUrls: ['./secondary-nav-block-list.component.scss'],
})
export class SecondaryNavBlockListComponent implements AfterViewInit {
  @Input() navBlocks: Partial<NavBlock>[] = [];

  constructor(private element: ElementRef) {}
  // TODO: Update when new release of CL Library is pushed.
  ngAfterViewInit() {
    const elements = document.querySelectorAll('.jb-grid-ph-s.pb0.w-100.pr4');
    elements.forEach(element => {
      element.classList.remove('pr4');
    });
  }
}
